














































































































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import VoteButton from '../components/VoteButton.vue';
import { Icon, Toast, Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
import { getDetail, share, nextLastId } from '../api';
import { isWeiXin } from '@/common/ts/common';

Vue.use(Icon)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(Toast);
@Component({
  components: {
    XGplayer,
    VoteButton,
  },
})
export default class Detail extends Vue {
  detailData: any = {
    cover: [],
  };
  ids: any = {};
  index: any = '';
  type: any = '';

  get detail() {
    return this.$route.query;
  }
  async mounted() {
    const res = await getDetail(this.detail.id as string);
    this.detailData = res.data;
    this.type = this.detail.type;
    const ids = await nextLastId(this.detail.id, this.detail.type);
    this.ids = ids.data;
    this.index = this.detail.index;
  }
  updateZan(data: string) {
    this.detailData.votes = data;
    // this.getData();
    // this.$emit('updateZan');
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
  changeDetail(type: string) {
    const index = Number(this.index);
    // console.log(
    //   `${location.origin}${location.pathname}?id=${this.ids.nextId}&type=${
    //     this.detail.type
    //   }&index=${index + 1}`,
    // );
    // if (1 === 1) {
    //   return;
    // }
    if (type === 'next') {
      if (String(this.ids.nextId) !== '0') {
        location.href = `${location.origin}${location.pathname}?id=${
          this.ids.nextId
        }&type=${this.detail.type}&index=${index + 1}`;
      } else {
        Toast('这已经是最后一条了~');
      }
    } else if (type === 'last') {
      if (String(this.ids.lastId) !== '0') {
        location.href = `${location.origin}${location.pathname}?id=${
          this.ids.lastId
        }&type=${this.detail.type}&index=${index - 1}`;
      } else {
        Toast('这是第一条哦，点击下一条查看更多~');
      }
    }
  }

  returnPage() {
    window.localStorage.setItem('sweetTigernowid', this.detail.id + '');
    window.localStorage.setItem('sweetTigernowtype', this.detail.type + '');
    this.$router.go(-1);
    // this.$router.push({
    //   path: 'home',
    // });
    // if (window.history.length <= 1) {
    //   this.$router.push({
    //     path: 'home',
    //   });
    // } else {
    //   this.$router.go(-1);
    // }
  }
}
